export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const CLEAR_PAYMENTS = 'CLEAR_PAYMENTS'
export const LOADING_TRUE = 'LOADING_TRUE'
export const LOADING_FALSE = 'LOADING_FALSE'
